// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"18ff58f0","453":"2838b7a7"}[chunkId] + ".chunk.js";
};